/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BedType } from './BedType';
import {
    BedTypeFromJSON,
    BedTypeFromJSONTyped,
    BedTypeToJSON,
} from './BedType';

/**
 * 
 * @export
 * @interface FindAllBedTypes200Response
 */
export interface FindAllBedTypes200Response {
    /**
     * 
     * @type {Array<BedType>}
     * @memberof FindAllBedTypes200Response
     */
    data?: Array<BedType>;
}

/**
 * Check if a given object implements the FindAllBedTypes200Response interface.
 */
export function instanceOfFindAllBedTypes200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllBedTypes200ResponseFromJSON(json: any): FindAllBedTypes200Response {
    return FindAllBedTypes200ResponseFromJSONTyped(json, false);
}

export function FindAllBedTypes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllBedTypes200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(BedTypeFromJSON)),
    };
}

export function FindAllBedTypes200ResponseToJSON(value?: FindAllBedTypes200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(BedTypeToJSON)),
    };
}

